/**
 * Navigation utilities for Electron/Browser compatibility
 * 
 * Handles navigation differences between:
 * - BrowserRouter (web) - uses regular paths like /auth/login
 * - HashRouter (Electron) - uses hash paths like /#/auth/login
 */

// Detect if running in Electron PRODUCTION (file:// protocol)
// In Electron dev mode, we use localhost so regular navigation works fine
export const isElectronProduction = () => {
  if (typeof window === 'undefined') return false;
  
  // Check for file:// protocol (Electron production)
  const isFileProtocol = window.location.protocol === 'file:';
  
  // Also check for Electron API being available (fallback)
  const hasElectronAPI = !!window.electronAPI?.isElectron;
  
  // In production, we use file:// protocol, but in dev we use localhost
  // Only use hash router when it's file:// protocol
  return isFileProtocol;
};

/**
 * Navigate to a path, handling both BrowserRouter and HashRouter
 * Use this for programmatic navigation outside of React components
 * 
 * @param {string} path - The path to navigate to (e.g., '/auth/login')
 */
export const navigateTo = (path) => {
  if (isElectronProduction()) {
    // In Electron production with HashRouter, we need to set the hash
    window.location.hash = path;
  } else {
    // In browser/Electron dev with BrowserRouter, use regular navigation
    window.location.href = path;
  }
};

/**
 * Get the current path (works with both router types)
 */
export const getCurrentPath = () => {
  if (isElectronProduction()) {
    // Remove the leading # from hash
    return window.location.hash.slice(1) || '/';
  }
  return window.location.pathname;
};
